import React from "react";
import { Button, MenuSection } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { ProductAccessibilityEnum } from "../types/Api";
import { usePermissions } from "../hooks/usePermissions";
export var ProductActionButtons = function (_a) {
    var product = _a.product, onEdit = _a.onEdit, onMakePublic = _a.onMakePublic, onMakePrivate = _a.onMakePrivate, onAddProductNumber = _a.onAddProductNumber, onRequestCoEditionNumber = _a.onRequestCoEditionNumber, onPreview = _a.onPreview, onGenerateBarcode = _a.onGenerateBarcode, onDelete = _a.onDelete;
    var _b = usePermissions(), canEditProductItem = _b.canEditProductItem, canChangeProductAccessibility = _b.canChangeProductAccessibility;
    var isPrivate = product.accessibility === ProductAccessibilityEnum.PRIVATE;
    var canEdit = canEditProductItem(product);
    var canChangeAccessibility = canChangeProductAccessibility(product);
    if (!canEdit &&
        !canChangeAccessibility &&
        !onAddProductNumber &&
        !onRequestCoEditionNumber &&
        !onPreview &&
        !onGenerateBarcode &&
        !onDelete) {
        return null;
    }
    return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
        canEdit && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: onEdit, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-agency.product.button.edit" }))),
        canChangeAccessibility && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: isPrivate ? onMakePublic : onMakePrivate, fullWidth: true },
            React.createElement(FormattedMessage, { id: isPrivate
                    ? "ui-br-agency.product.button.makePublic"
                    : "ui-br-agency.product.button.makePrivate" }))),
        onAddProductNumber && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: onAddProductNumber, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-agency.product.action.addProductNumber" }))),
        onRequestCoEditionNumber && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: onRequestCoEditionNumber, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-agency.product.action.requestCoEditionNumber" }))),
        onPreview && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: onPreview, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-agency.preview.action" }))),
        onGenerateBarcode && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: onGenerateBarcode, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-agency.product.barcode.action" }))),
        onDelete && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: onDelete, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.delete" })))));
};
